/** @format */

export interface PrimaryCategories {
  id: string;
  identifier: string;
}
